module.exports = __webpack_public_path__ + "static/media/Imagen_7.4b8802fd.jpg";